$shm_ba_mention_stats_task_list_head $shm_list_head
	search_showed false
	Controls $mol_view
		sub <= controls /
	controls /
